import { projectRole, oldProjectRoleNames } from '@model';

const TEAM_MEMBER_ROLE = oldProjectRoleNames[2];

export const PWC_DIRECTORY_ERROR = 'Not found in PwC directory';

export const PWC_VALIDATION_ERROR = 'Failed to validate. Please try again.';

export const isPwcEmployeeMatch = (item) => Boolean(item?.guid);

export const getPwcEmployeeItems = (response) => {
  if (Array.isArray(response)) {
    return response;
  }

  if (Array.isArray(response?.data)) {
    return response.data;
  }

  return [];
};

export const buildPwcEmployeeResponseMap = (response) => {
  const map = new Map();
  const items = getPwcEmployeeItems(response);

  items.forEach((item) => {
    if (item?.email && isPwcEmployeeMatch(item)) {
      map.set(item.email.toLowerCase(), item);
    }
  });

  return map;
};

export const mapPwcApiUserToMember = (apiUser) => ({
  fullName: apiUser.name,
  email: apiUser.email,
  country: apiUser.country,
  guid: apiUser.guid,
  staffLevel: apiUser.staff || '',
  location: apiUser.workLoc,
  department: apiUser.jobFunc,
  nonUS: apiUser.nonUS,
  isEUBased: null,
  isLead: false,
  isManager: false,
  permission: projectRole['View-Only'],
  role_name: TEAM_MEMBER_ROLE,
});

export const buildPwcEmployeePreviewRow = (email, item) => {
  if (!item || !isPwcEmployeeMatch(item)) {
    return {
      email,
      status: 'invalid',
      reason: PWC_DIRECTORY_ERROR,
      details: PWC_DIRECTORY_ERROR,
    };
  }

  return {
    email,
    status: 'valid',
    reason: '',
    details: `${item.name} — will be added as Viewer / Team Member`,
    memberData: mapPwcApiUserToMember(item),
  };
};
